module.exports = __webpack_public_path__ + "static/img/activate7.ffbe56a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activate7.svg
// module id = 1439
// module chunks = 180